import React from 'react';

import PropTypes from 'prop-types';
import { Header, Segment, Button, Label } from 'semantic-ui-react';

import { reviewResponseShape } from '../../../../types';
import { isReviewResponseEmpty } from '../../../ReviewsTable/ReviewsTable.utils';
import ResponseDatetime from '../ResponseDatetime/ResponseDatetime';

import './CustomResponse.scss';

const propTypes = {
  reviewResponse: reviewResponseShape.isRequired,
  replyText: PropTypes.string.isRequired,
  setReplyText: PropTypes.func.isRequired,
  isEditing: PropTypes.bool.isRequired,
  setIsEditing: PropTypes.func.isRequired,
};

const defaultProps = {};

function CustomResponse({ reviewResponse, replyText, setReplyText, isEditing, setIsEditing }) {
  if (!isEditing) return null;

  const isEmptyResponse = isReviewResponseEmpty(reviewResponse);
  const { content, status, statusDisplay, submittedAt, publishAt } = reviewResponse;

  function handleAutoResponseClick() {
    setIsEditing(false);
    setReplyText(content);
  }

  return (
    <div className="custom-response">
      <Header>Write Your Own Response</Header>
      <Segment attached>
        {!isEmptyResponse && (
          <div className="review-meta">
            <span className="review-response-status">
              <Label basic>{statusDisplay || status}</Label>
            </span>
            {publishAt && (
              <span className="review-response-date">
                <ResponseDatetime submittedAt={submittedAt} publishAt={publishAt} />
              </span>
            )}
          </div>
        )}

        <div className="custom-response-review-text">
          <textarea
            className="ui fluid"
            rows="4"
            placeholder="Write your reply here..."
            value={replyText}
            onChange={(e) => setReplyText(e.target.value)}
            aria-label="Custom review response"
            id="custom-review-response"
          />
        </div>

        {!isEmptyResponse && (
          <div className="custom-response-actions">
            <Button
              basic
              onClick={handleAutoResponseClick}
              icon="undo"
              content="Use Auto Response"
            />
          </div>
        )}
      </Segment>
    </div>
  );
}

CustomResponse.propTypes = propTypes;
CustomResponse.defaultProps = defaultProps;

export default CustomResponse;
